import html2canvas from "html2canvas"
import jsPDF from "jspdf";

const paperStandardSize = {
    a1: [594, 841],
    a2: [420, 594],
    a3: [297, 420],
    a4: [210, 297],
    a5: [148, 210],
    a6: [105, 148],
    b1: [788, 1091],
    b2: [545, 788],
    b3: [394, 545],
    b4: [272, 394],
    b5: [197, 272],
    b6: [136, 197],
};

export default {
  async exportToPDF(elements, format, orientation, filenm) {
    var retVal = true;

    try {
      var doc = new jsPDF({
        orientation: orientation,
        unit: 'mm',
        format: format,
        putOnlyUsedFonts: true,
        floatPrecision: 'smart',
        compress: true
      });

      var page_cnt = 0;
      for (const element of elements) {
        await html2canvas(element, {
          allowTaint: false,
          useCORS: true, 	
          logging: false, 	
          scale: 3
        }).then(canvas => {         
          // base64 url 로 변환
          var imgData = canvas.toDataURL('image/jpeg');

          // default orientation : landscape
          var imgWidth = paperStandardSize[format][1];
          var aspectRatio = paperStandardSize[format][0] / paperStandardSize[format][1];

          if (orientation == 'p' || orientation == 'portrait') {
            imgWidth = paperStandardSize[format][0]; 
            aspectRatio = paperStandardSize[format][1] / paperStandardSize[format][0];
          }

          var imgHeight = canvas.height * imgWidth / canvas.width;
          var pageWidth = imgWidth;
          var pageHeight = imgWidth * aspectRatio;

          if (pageHeight < imgHeight) {
            imgWidth = imgWidth * (pageHeight / imgHeight);
            imgHeight = pageHeight;
          }

          var margin = 3;
          var border = 0.8;
          var pad_x = (pageWidth - imgWidth) / 2 + margin;
          var pad_y = (pageHeight - imgHeight) / 2 + margin;

          if (page_cnt > 0)
            doc.addPage();

          doc.setFillColor(245);
          doc.rect(0, 0, pageWidth, pageHeight, "F");
          doc.setFillColor(230);
          doc.roundedRect(pad_x - border, 
                          pad_y - border, 
                          imgWidth - (margin * 2) + (border * 2), 
                          imgHeight - (margin * 2) + (border * 2), 
                          border, border, "F");
          doc.addImage(imgData, 'jpeg', pad_x, pad_y, imgWidth - (margin * 2), imgHeight - (margin * 2));

          page_cnt++;
        });
      }

      // 파일 저장
      doc.save(filenm);
    }
    catch (e) {
      console.log('Exception : ' + e);
      retVal = false;
    }

    return retVal;
  }
}


